import { ButtonIcon } from '../ButtonIcon'
import { ChevronLeft, ChevronRight } from '@/icons'
import i18next from 'i18next'
import { CSSProperties } from 'react'
import { cn } from '@dashboard/ui'

interface PaginationProps {
  hasNext: boolean
  page: number
  onPageChange: (page: number) => void
  pageItems?: number
  style?: CSSProperties
  className?: string
}

export const Pagination = ({ hasNext, page, onPageChange, pageItems, style, className }: PaginationProps) => {
  const hasPrev = page > 1

  const onClickPrev = () => {
    onPageChange(page - 1)
  }

  const onClickNext = () => {
    onPageChange(page + 1)
  }

  return (
    <div
      style={style}
      className={cn(
        'sticky bottom-0 left-0 flex items-center justify-end border-t border-border-secondary bg-fg-primary p-[18px]',
        className,
      )}
    >
      {pageItems !== undefined && (
        <div className="mr-auto text-[14px] text-fg-tertiary">
          {pageItems} {i18next.t('pagination.results')}
        </div>
      )}
      <div className="flex gap-2">
        <ButtonIcon variant="outline" color="secondary" size="sm" disabled={!hasPrev} onClick={onClickPrev}>
          <ChevronLeft />
        </ButtonIcon>
        <ButtonIcon variant="outline" color="secondary" size="sm" disabled={!hasNext} onClick={onClickNext}>
          <ChevronRight />
        </ButtonIcon>
      </div>
    </div>
  )
}
